import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/payment' },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/Auth.vue'),
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('./views/Payment.vue'),
    },
    {
      path: '/service',
      name: 'service',
      component: () => import('./views/Service.vue'),
    },
    {
      path: '/new_invoice',
      name: 'new_invoice',
      component: () => import('./views/NewInvoice.vue'),
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: () => import('./views/Invoice.vue'),
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('./views/Mine.vue'),
    },
    {
      path: '/reset_password',
      name: 'reset_password',
      component: () => import('./views/ResetPassword.vue'),
    },
  ],
})
